import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://studioazzanostp.it';
const SITE_NAME = 'Studio Professionale Azzano Cantarutti SRL - Società tra professionisti';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

const SEO_DATA = {
  '/': {
    title: 'Commercialista Online per Startup ed E-commerce | Studio Professionale Azzano Cantarutti SRL',
    description: 'Commercialista e Revisore Contabile a San Daniele del Friuli (Udine). Consulenza fiscale specializzata per startup, e-commerce e business digitali. Operativi in Friuli Venezia Giulia, Veneto, Trentino e tutta Italia.',
    keywords: 'commercialista online, commercialista startup, commercialista ecommerce, consulente fiscale Udine, commercialista Friuli, commercialista Triveneto, partita IVA online, regime forfettario, consulenza fiscale San Daniele del Friuli',
  },
  '/chi-sono': {
    title: 'Dott. Aurelio Azzano Cantarutti - Commercialista e Revisore Contabile | Udine',
    description: 'Dottore Commercialista e Revisore Contabile con oltre 30 anni di esperienza. Specializzato in startup, e-commerce e business digitali. Studio a San Daniele del Friuli (UD), operativo in tutto il Triveneto e Italia.',
    keywords: 'Aurelio Azzano Cantarutti, commercialista Udine, revisore contabile Friuli Venezia Giulia, dottore commercialista San Daniele del Friuli, studio commercialista Triveneto',
  },
  '/servizi': {
    title: 'Servizi Fiscali e Contabili per Startup, E-commerce e Imprese | Studio Azzano',
    description: 'Consulenza fiscale, contabile e previdenziale per startup innovative, e-commerce, imprese e professionisti. Apertura P.IVA, regime forfettario, fiscalità internazionale, innovazione digitale. Udine, Triveneto, Italia.',
    keywords: 'servizi fiscali startup, consulenza contabile ecommerce, apertura partita IVA, regime forfettario, fiscalità internazionale, innovazione digitale, consulenza tributaria Udine, commercialista imprese Veneto',
  },
  '/consulenza': {
    title: 'Prenota Consulenza Online con il Commercialista | Studio Professionale Azzano Cantarutti SRL',
    description: 'Prenota una consulenza online via videoconferenza con il Dott. Azzano Cantarutti. Consulenze per startup (€150), e-commerce (€200), business model test (€200). Disponibile per clienti in tutta Italia.',
    keywords: 'consulenza commercialista online, consulenza fiscale videoconferenza, prenotazione commercialista, consulenza startup online, consulenza ecommerce online',
  },
  '/contatti': {
    title: 'Contatti - Studio Professionale Azzano Cantarutti SRL | San Daniele del Friuli (Udine)',
    description: 'Contatta lo Studio Professionale Azzano Cantarutti SRL a San Daniele del Friuli (UD). Piazza Pellegrino 8, 33038. Consulenza fiscale per startup, e-commerce e imprese nel Triveneto e in tutta Italia.',
    keywords: 'contatti commercialista Udine, studio commercialista San Daniele del Friuli, commercialista Friuli Venezia Giulia, indirizzo studio Azzano Cantarutti',
  },
  '/utility': {
    title: 'Utility Fiscali Online - Calcolatori IVA, Codice Fiscale, INPS | Studio Azzano',
    description: 'Strumenti fiscali gratuiti: calcolatore IVA, generatore codice fiscale con tutti i comuni italiani, calcolo contributi INPS per artigiani, commercianti e professionisti.',
    keywords: 'calcolatore IVA online, calcolo codice fiscale, contributi INPS online, strumenti fiscali gratuiti, calcolatore contributi artigiani commercianti',
  },
  '/novita': {
    title: 'Novità Fiscali e Aggiornamenti Normativi | Studio Professionale Azzano Cantarutti SRL',
    description: 'Resta aggiornato sulle ultime novità fiscali, tributarie e normative italiane. Guide, approfondimenti e scadenze fiscali per imprese e professionisti.',
    keywords: 'novità fiscali 2026, aggiornamenti normativi, scadenze fiscali, news tributarie, guide fiscali Italia',
  },
};

const PageSEO = ({ path = '/', customTitle, customDescription }) => {
  const seo = SEO_DATA[path] || SEO_DATA['/'];
  const title = customTitle || seo.title;
  const description = customDescription || seo.description;
  const url = `${SITE_URL}${path === '/' ? '' : path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={seo.keywords} />
      <link rel="canonical" href={url} />

      {/* Geo targeting */}
      <meta name="geo.region" content="IT-36" />
      <meta name="geo.placename" content="San Daniele del Friuli" />
      <meta name="geo.position" content="46.1578;13.0122" />
      <meta name="ICBM" content="46.1578, 13.0122" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={DEFAULT_IMAGE} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="it_IT" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />
    </Helmet>
  );
};

export default PageSEO;
